import { useTextes } from '@common/config';
import { OrganismeDetailsContext } from '@common/contexts';
import { useSessionContext } from '@common/hooks';
import { useCurrentCampagne } from "@common/hooks/campagne";
import { useOfaDetails } from '@common/hooks/organisme';
import { CampagneStatut } from "@common/services";
import { OfaMessageBanner } from "@common/ui";
import React from 'react';
import { useSelector } from 'react-redux';
import { DashboardInformations } from './components/Informations/DashboardInformations';
import { DashboardStepperState } from './components/VerticalStepper/stores/dashboard-stepper.slice';
import { VerticalStepper } from './components/VerticalStepper/VerticalStepper';

export const Dashboard = () => {
  const { isNewDeclarationNeeded }: DashboardStepperState = useSelector(s => s.dashboardStepperSlice);
  const t = useTextes('ParcoursOfa', 'Etapier');
  const { organismeId } = useSessionContext();
  const { organisme, isLoading } = useOfaDetails({ id: organismeId });

  const t_campagne = useTextes('Commun', 'Campagne');
  const { campagne } = useCurrentCampagne();
  if (!campagne || !organisme) return null;
  const isCampagneArchived = (campagne.statut === CampagneStatut.ARCHIVEE);

  if (isLoading) return null;

  return (
    <OrganismeDetailsContext.Provider value={organisme}>
      <div className={'flex flex-col gap-6'}>

        {isCampagneArchived && (
          <OfaMessageBanner title={t_campagne['CAMPAGNE_TERMINEE_MSG1']}
                            subtitle={organisme.depotProlonge
                              ? t_campagne['CAMPAGNE_TERMINEE_MSG2']
                              : t_campagne['CAMPAGNE_TERMINEE_MSG3']} />
        )}

        <DashboardInformations />

        <h3 className="mb-0!">{t['ETAPIER_TEXTE1']}</h3>

        <span>{t['ETAPIER_TEXTE2']}</span>

        <span className={'text-sm'}>{t['ETAPIER_TEXTE3']}</span>

        {isNewDeclarationNeeded && (
          <span className={'text-red-500'}>{t['ETAPIER_REGENERER_DECLARATION']}</span>
        )}

        <VerticalStepper />
      </div>
    </OrganismeDetailsContext.Provider>
  );
};